export const AUTH_TOKEN = 'STOCK_VAULT_DEALER_AUTH_TOKEN';
